import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import { List } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Dialog from 'material-ui/Dialog';


import Toolbar from '../App/Toolbar';
import Snackbar from 'material-ui/Snackbar';
import SearchToolbar from '../App/SearchToolbar.react';
import AddEntityButton from './AddEntityButton';
import AddEntityActionButton from './AddEntityActionButton';
import SpeedDial from '../Common/SpeedDial';

import AppStore from '../../stores/AppStore';
import SearchStore from '../../stores/SearchStore';

const style = {
    paddingBottom: 0,
    borderTop: '1px solid #e0e0e0',
    backgroundColor: '#fff',
};

/**
 *
 * ListView component
 *
 * @prop items array, collection of simple objects
 * @prop itemDecorator component, React component used to render the items
 * @prop string title
 * @prop actions array, collection of MenuItem for the context menu
 * @prop array|object sortOptions, simple object or collection containing label and value.
 *    - example
 *      [
 *          {label: "First name", value: 'firstName'},
 *          {label: "Last name", value: 'lastName'}
 *      ]
 * @prop function sortAction
 * @prop function searchAction
 * @prop newEntityUrl string, route for new entity form
 */
const ListView = React.createClass({


    getInitialState: function() {
        return {
            searchMode: this.props.searchMode,
            results: [],
            successMessageDuration: 1500,
            showSuccessMessage: false,
            showErrorMessage: false,
            lastErrorMessage: ''
        };
    },

    componentDidMount: function() {
        AppStore.addSearchResultListener(this._onSearchResult); // BW compatibility
        AppStore.addFormSubmitErrorListener(this._onErrorMessage);
        this.searchListener = SearchStore.addListener(this.onSearchResult);
        if (!!this.props.searchMode && !!this.props.searchType) {
            this.onSearchResult();
        }
    },

    componentWillUnmount: function() {
        AppStore.removeSearchResultListener(this._onSearchResult); // BW compatibility
        AppStore.removeFormSubmitErrorListener(this._onErrorMessage);
        this.searchListener.remove();
    },

    render: function() {

        let newEntityButton, toolbar, dialog;


        let items = (this.state.searchMode) ? this.state.results : this.props.items;
        if (!!this.props.sortCallback) {
            items.sort(this.props.sortCallback);
        }

        const Decorator = this.props.itemDecorator;

        if(this.props.newEntityUrl) {
            newEntityButton = <AddEntityButton newEntityUrl={this.props.newEntityUrl} />;
        } else if (this.props.newEntityAction) {
            newEntityButton = <AddEntityActionButton onClick={this.props.newEntityAction} />;
        } else if (this.props.newEntityActions) {
            newEntityButton = <SpeedDial actions={this.props.newEntityActions} />;
        }

        if(this.state.searchMode) {
            toolbar = <SearchToolbar
                        backTo={this.props.searchModeOnly ? () => browserHistory.push(this.props.backTo) : this._toggleSearchMode}
                        action={this._onSearch}
                        searchResult={this.state.results}
                      />;
        } else {
            toolbar = (
                <Toolbar
                    title={this.props.title}
                    backButton={this.props.backButton}
                    backTo={this.props.backTo}
                    actions={this.props.actions}
                    searchAction={this.props.searchAction}
                    sortOptions={this.props.sortOptions}
                    sortAction={this.props.sortAction}
                    filterOptions={this.props.filterOptions}
                    filterAction={this.props.filterAction}
                    searchable={!!this.props.searchAction}
                    toggleSearchMode={this._toggleSearchMode}
                />
            );
        }
        return (
            <div>
                {toolbar}
                <div className='cent-main'>
                    <List style={style} className='cent-list'>
                        {items.map((item, i) => (
                            <div key={i} >
                                <Decorator actions={this.props.itemActions} data={item} {...this.props.itemProps} />
                                <Divider />
                            </div>
                        ))}

                    </List>
                </div>
                <Snackbar
                    open={this.state.showErrorMessage}
                    message={this.state.lastErrorMessage}
                    action="OK"
                    onActionTouchTap={this._handleSnackbarRequestClose}
                    onRequestClose={this._handleSnackbarRequestClose}
                />
                {(!!this.props.dialog && this.props.dialog.open) && <Dialog {...this.props.dialog} /> }
                {this.props.children}
                {newEntityButton}
            </div>
        );
    },
    _toggleSearchMode: function() {
        const searchMode = !this.state.searchMode;
        this.setState({searchMode});

        if (!!this.props.toggleSearchMode) {
            this.props.toggleSearchMode(searchMode);
        }
    },
    _onSearch: function(searchText) {
        if (!this.props.minSearchTextSize || this.props.minSearchTextSize <= searchText.length) {
            this.props.searchAction(searchText);
        }
    },

    // keeping for BW compatibility
    _onSearchResult: function() {
        const results = AppStore.getSearchResult();
        this.setState({ results });
    },

    onSearchResult: function() {
        const { isFetching, results } = SearchStore.getByKey(this.props.searchType) || {};
        if (!isFetching && !!results) {
            this.setState({ results });
        }
    },
    
    // message handling
    _handleSnackbarRequestClose: function() {
        this.setState( { showSuccessMessage: false, showErrorMessage: false } );
    },
    
    _onErrorMessage: function() {
        this.setState({ showProgress: false, showErrorMessage: true, lastErrorMessage: AppStore.getLastError() } );
        if (!!this.props.onError) {
            this.props.onError(this.state.lastErrorMessage);
        }
    }

    
});

ListView.propTypes = {
    items:          PropTypes.array.isRequired,
    itemDecorator:  PropTypes.func,
    title:          PropTypes.string,
    itemActions:    PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    itemProps:      PropTypes.object,
    actions:        PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    sortOptions:    PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    sortAction:     PropTypes.func,
    sortCallback:   PropTypes.func,
    filterOptions:    PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    filterAction:   PropTypes.func,
    searchAction:   PropTypes.func,
    searchMode:     PropTypes.bool, // initial
    searchModeOnly: PropTypes.bool,
    searchType:     PropTypes.string,
    toggleSearchMode: PropTypes.func,
    minSearchTextSize: PropTypes.number,
    newEntityUrl:   PropTypes.string,
    newEntityAction: PropTypes.func,
    newEntityActions: PropTypes.arrayOf(
        PropTypes.shape({
            label:      PropTypes.string.isRequired,
            link:       PropTypes.string,
            icon:       PropTypes.object
        })
    ),
    dialog:         PropTypes.object,
    backButton:     PropTypes.bool,
    backTo:         PropTypes.string
};

ListView.defaultProps =  {
    searchMode: false,
    searchModeOnly: false,
    minSearchTextSize: 2,
    dialog:     { open: false },
    backButton: false,
    backTo:     null,
    itemProps:  {}
};

export default ListView;
